import React, { Component } from 'react';

class DetailButton extends Component {
  render() {
    const text = 'コースを詳しくみる';

    return (
      <div
        style={{ ...this.props.style}}
        className="DetailButtonContainer"
      >
        <div
          className="DetailButton"
          onClick={this.props.onClick}
        >
          {text}
        </div>
      </div>
    );
  }
};


export default DetailButton;
